/**
 * This type represents the types for a response envelope
 */
export enum ResponseEnvelopeType {
  INFO = "INFO",
  WARN = "WARN",
  ERROR = "ERROR",
}
